export const filterActionTypes = {
  LOCATION: 'LOCATION',
  ITEMS_TYPE: 'ITEMS_TYPE',
  ITEMS: 'ITEMS',
  DATE: 'DATE',
  UPDATE_FILTERS: 'UPDATE_FILTERS',
  UPDATE_PRICELIST:'UPDATE_PRICELIST'
};
